/** 达克多型号（同 VID/PID，靠 drvSN 区分） */

export const V80_DRV_SN = 0x0103;
export const V102_LOGO_DRV_SN = 0x0101;
export const V102_SMG_DRV_SN = 0x0102;

export const V80_MATRIX_DATA_LENGTH = 0x15;
export const V80_MATRIX_KEY_COUNT = 20;
export const V102_MATRIX_DATA_LENGTH = 0x14;
export const V102_MATRIX_KEY_COUNT = 19;
export const DAKAI_MATRIX_COLUMNS = 8;

/** @deprecated 使用 DAKAI_MATRIX_COLUMNS */
export const V80_MATRIX_COLUMNS = DAKAI_MATRIX_COLUMNS;

export type DakaiModelId = "v80" | "v102";

export type DakaiModelSpec = {
  drvSN: number;
  modelId: DakaiModelId;
  name: string;
  displayname: string;
  deviceId: string;
  keyboardType: "87" | "v102";
  matrixDataLength: number;
  matrixKeyCount: number;
  hasLogoLight: boolean;
  fnBlockedPositions: readonly number[];
  /** Fn 层出厂空键（仅 V80 有明确列表） */
  fnDefaultEmptyPositions: readonly number[];
};

export const V80_FN_BLOCKED_POSITIONS: readonly number[] = [
  0x00, 0x01, 0x07, 0x0d, 0x0e, 0x11,
];

export const V102_FN_BLOCKED_POSITIONS: readonly number[] = [
  0x00, 0x01, 0x02, 0x11, 0x48, 0xd2,
];

export const V80_FN_DEFAULT_EMPTY_POSITIONS: readonly number[] = [
  0x20, 0x31, 0x21, 0x68, 0x2e, 0x06, 0x08,
];

export const DAKAI_MODEL_SPECS: Readonly<Record<number, DakaiModelSpec>> = {
  [V102_LOGO_DRV_SN]: {
    drvSN: V102_LOGO_DRV_SN,
    modelId: "v102",
    name: "V102_LOGO",
    displayname: "V102",
    deviceId: "v102",
    keyboardType: "v102",
    matrixDataLength: V102_MATRIX_DATA_LENGTH,
    matrixKeyCount: V102_MATRIX_KEY_COUNT,
    hasLogoLight: true,
    fnBlockedPositions: V102_FN_BLOCKED_POSITIONS,
    fnDefaultEmptyPositions: [],
  },
  [V102_SMG_DRV_SN]: {
    drvSN: V102_SMG_DRV_SN,
    modelId: "v102",
    name: "V102_SMG",
    displayname: "V102",
    deviceId: "v102",
    keyboardType: "v102",
    matrixDataLength: V102_MATRIX_DATA_LENGTH,
    matrixKeyCount: V102_MATRIX_KEY_COUNT,
    hasLogoLight: false,
    fnBlockedPositions: V102_FN_BLOCKED_POSITIONS,
    fnDefaultEmptyPositions: [],
  },
  [V80_DRV_SN]: {
    drvSN: V80_DRV_SN,
    modelId: "v80",
    name: "V80_87K",
    displayname: "V80",
    deviceId: "v80",
    keyboardType: "87",
    matrixDataLength: V80_MATRIX_DATA_LENGTH,
    matrixKeyCount: V80_MATRIX_KEY_COUNT,
    hasLogoLight: true,
    fnBlockedPositions: V80_FN_BLOCKED_POSITIONS,
    fnDefaultEmptyPositions: V80_FN_DEFAULT_EMPTY_POSITIONS,
  },
};

export function resolveDakaiModelSpec(
  drvSN: number
): DakaiModelSpec | undefined {
  return DAKAI_MODEL_SPECS[drvSN];
}

export function isSupportedDakaiDrvSN(drvSN: number): boolean {
  return drvSN in DAKAI_MODEL_SPECS;
}
